// extracted by mini-css-extract-plugin
module.exports = {"form":"info-step_form__-Rz1M","actions":"info-step_actions__370hy","error-message":"info-step_error-message__1tbhR","receive-code":"info-step_receive-code__3koHG"};